import app from 'flarum/forum/app';
import Page from 'flarum/common/components/Page';
import IndexPage from 'flarum/forum/components/IndexPage';
import Button from 'flarum/common/components/Button';
import LinkButton from 'flarum/common/components/LinkButton';
import Switch from 'flarum/common/components/Switch';
import listItems from 'flarum/common/helpers/listItems';
import icon from 'flarum/common/helpers/icon';
import humanTime from 'flarum/common/helpers/humanTime';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import Model from 'flarum/common/Model';
import {ApiPayloadPlural} from 'flarum/common/Store';

export default class EventsPage extends Page {
    showAllSubmissions: boolean = false
    forms: Model[] | null = null
    submissions: Model[] = []

    oninit(vnode: any) {
        super.oninit(vnode);

        this.refresh();
    }

    refresh() {
        this.forms = null;
        this.submissions = [];

        app.request<ApiPayloadPlural>({
            method: 'GET',
            url: app.forum.attribute('apiUrl') + '/formulaire/forms',
            params: {
                filter: {
                    q: 'type:standalone',
                },
            },
        }).then(result => {
            this.forms = app.store.pushPayload(result);
            m.redraw();
        });

        if (app.session.user) {
            app.request<ApiPayloadPlural>({
                method: 'GET',
                url: app.forum.attribute('apiUrl') + '/formulaire/submissions',
                params: {
                    filter: this.showAllSubmissions ? {} : {
                        q: 'user:' + app.session.user.username(),
                    },
                    include: 'user,form,files',
                },
            }).then(result => {
                this.submissions = app.store.pushPayload(result);
                m.redraw();
            });
        }
    }

    view() {
        if (this.forms === null) {
            return LoadingIndicator.component({className: 'LoadingIndicator--block'});
        }

        return m('div', [
            IndexPage.prototype.hero(),
            m('.container', m('.sideNavContainer', [
                m('nav.IndexPage-nav.sideNav', m('ul', listItems(IndexPage.prototype.sidebarItems().toArray()))),
                m('.sideNavOffset', [
                    app.forum.attribute('formulaireCanManage') ? Switch.component({
                        state: this.showAllSubmissions,
                        onchange: (value: boolean) => {
                            this.showAllSubmissions = value;
                            this.refresh();
                        },
                    }, 'Afficher les inscriptions de tout le monde') : null,
                    this.forms.length > 0 ? this.forms.map(form => {
                        const title = form.title();
                        const badges = form.badges().toArray();

                        const isCoupe = title.indexOf('Coupe') !== -1;

                        const date = form.attribute('subtitle');

                        const submissions = this.submissions.filter(submission => submission.form().id() === form.id());

                        return m('.RobotsJUEvent', [
                            m('.RobotsJUEventIcon', title.indexOf('Coupe') !== -1 ? m('img', {
                                src: app.forum.attribute('baseUrl') + '/assets/coupe-logo.svg',
                            }) : icon('fas fa-stopwatch')),
                            m('.RobotsJUEventDetails', [
                                m('.RobotsJUEventTitle', [
                                    form.title(),
                                    badges.length ? [' ', m('ul.badges', listItems(badges))] : null,
                                ]),
                                date ? m('.RobotsJUEventDate', date) : null,
                            ]),
                            LinkButton.component({
                                className: 'Button',
                                href: app.route.formulaireFormShow(form),
                            }, 'Inscrire une ' + (submissions.length ? 'autre ' : '') + 'équipe'),
                            submissions.length ? m('.RobotsJUSubmissions', [
                                m('h3', this.showAllSubmissions ? 'Toutes les équipes' : 'Mes équipes'),
                                m('table.FormulaireDataTable', [
                                    m('thead', m('tr', [
                                        isCoupe ? m('th', 'Logo') : null,
                                        m('th', 'Nom'),
                                        m('th', 'Date d\'inscription'),
                                        m('th'),
                                    ])),
                                    m('tbody', submissions.map(submission => {
                                        const data = submission.formData();
                                        const badges = submission.badges().toArray();

                                        let file = null;

                                        if (data && data.logo && Array.isArray(data.logo.value) && data.logo.value.length) {
                                            file = app.store.getById('formulaire-files', data.logo.value[0]);
                                        }

                                        return m('tr', [
                                            isCoupe ? m('td', file ? m('.RobotsJUTeamLogo', {
                                                style: {
                                                    backgroundImage: 'url("' + encodeURI(file.url()) + '")',
                                                },
                                            }) : m('em', 'Pas envoyé')) : null,
                                            m('td', [
                                                data && data.name ? data.name.value : m('em', 'Équipe sans nom'),
                                                badges.length ? [' ', m('ul.badges', listItems(badges))] : null,
                                                this.showAllSubmissions && data && data.email ? [
                                                    m('br'),
                                                    m('a', {
                                                        href: 'mailto:' + data.email.value,
                                                    }, data.email.value),
                                                ] : null,
                                            ]),
                                            m('td', humanTime(submission.createdAt())),
                                            m('td', LinkButton.component({
                                                className: 'Button',
                                                href: app.route.formulaireSubmission(submission),
                                            }, submission.attribute('canEdit') ? 'Modifier' : 'Détails')),
                                        ]);
                                    })),
                                ]),
                            ]) : null,
                        ]);
                    }) : m('p', 'Aucun événement pour le moment'),
                ]),
            ])),
        ]);
    }
}
